import './Style.css'
import * as React from "react";
import {
    FBFieldWithPriceBase,
    FBFieldWithPriceBaseProps,
    FBFieldWithPriceBaseState
} from "FormBuilder/Fields/Core/FBFieldWithPriceBase";
import {FBFieldWithPriceBaseOptions, PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {FBFieldBase, FBFieldBaseProps, FBFieldBaseState} from "FormBuilder/Fields/Core/FBFieldBase";
import {EventManager} from "shared/utilities/Events/EventManager";
import {FBFieldBaseOptions, FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {GetFieldOptions} from "FormBuilder/Events/GetFieldOptions";
import {GetField} from "FormBuilder/Events/GetField";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {FBRowOptions} from "FormBuilder/Core/FBRow.Options";
import {RefArray} from "shared/utilities/react/RefArray";
import {PublishOnceEvent} from "shared/utilities/Events/PublishOnceEvent";
import {PriceManager} from "FormBuilder/Utilities/Managers/PriceManager/PriceManager";
import {SingleEvent} from "shared/utilities/Events/SingleEvent";
import {SubTotalContainer} from "FormBuilder/Core/SubTotalContainer";
import {FBRepeaterOptions} from "./FBRepeater.Options";
import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import {GroupOfFieldsInGroupCalculator} from "FormBuilder/Core/Calulators/GroupOfFieldsInGroupCalculator";
import {FBRepeaterItem} from "./FBRepeaterItem";
import {GroupPricePerItemCalculator} from "FormBuilder/Core/Calulators/GroupPricePerItemCalculator";

import {FBRowModel} from "FormBuilder/Core/FBRow.Model";
import {FBRepeaterItemModel} from "./FBRepeaterItem.Model";
import {FBRepeaterModel} from "./FBRepeater.Model";
import {GetModel} from "FormBuilder/Events/GetModel";
import {FBGroupPanelModel} from "../FBGroupPanel/FBGroupPanel.Model";
import {FBGroupPanelOptions} from "../FBGroupPanel/FBGroupPanel.Options";
import {FBRepeaterItemOptions} from "./FBRepeaterItem.Options";
import {FBRow} from "FormBuilder/Core/FBRow";


export class FBRepeater extends FBFieldWithPriceBase<FBListProps,FBListState>{

    public Container:HTMLDivElement;

    constructor(props: FBListProps) {
        super(props);

    }


    protected InitializePriceCalculator() {

    }

    componentDidMount(): void {
        super.componentDidMount();
        let currentContainer=this.Container;
        this.Model.IsLoaded=true;
        this.Model.OnLoad.Publish();
        this.Model.InitializeConditions();

    }

    static defaultProps: Partial<FBListProps> = {

    };


    public SubRender() {
        if(this.Model.Options.ShowQuantitySelector)
        {
            return(
                this.Model.Options.QuantityPosition == "bottom" || this.Model.Options.QuantityPosition == "right" ?
                    <React.Fragment>
                        {this.GetInput(this.Model.Options.QuantityPosition)}
                        {this.GetQuantityInput()}

                        {this.GetPriceOrRequiredBox()}

                    </React.Fragment>:
                    <React.Fragment>
                        {this.GetQuantityInput()}
                        {this.GetInput(this.Model.Options.QuantityPosition)}

                        {this.GetPriceOrRequiredBox()}

                    </React.Fragment>
            )
        }
        return(
            <React.Fragment>
                {this.GetInput('')}

                {this.GetPriceOrRequiredBox()}

            </React.Fragment>
        )

    }



    GetQuantityInput(){
        return(
            <div className={'rnTextFieldQuantity '+ this.Model.Options.QuantityPosition}>
                <div className={'rednaoLabel'}>
                    <label style={{fontWeight:'bold'}}>{this.Model.Options.QuantityLabel}</label>
                </div>
                <input className={'rnInputQuantity'} placeholder={this.Model.Options.QuantityPlaceholder} style={{width:'100%'}} type={'text'} value={this.Model.Quantity}
                       onChange={x=>{this.Model.Quantity=this.Model.ParseNumber(x.target.value as any);this.Model.FireValueChanged()}}/>
            </div>

        )
    }

    GetInput(additionalClassNames:string){
        return (
            <div className={'rednaoGroupContainer rednaoRepeater'} >
                {this.Model.Options.Label!=''&&
                    <div>
                        <h3 className={'rnTitle'}>{this.Model.Options.Label}</h3>
                        <hr style={{margin:0,padding:0}}/>
                    </div>
                }

                {this.props.Model.CreatedRows.map((rowOptions,index)=>(
                    <FBRow  key={rowOptions.Columns[0].Field.Options.Id} Model={rowOptions}/>
                    ))}

                {this.props.Model.CreatedRows.length == 0 &&
                <div style={{marginTop: 2}}>
                    <button className={'rnbtn rnbtn-light'} title={'Add'} onClick={e=>{e.preventDefault();this.Model.AppendRow();}}>
                        <FontAwesomeIcon icon={faPlus}/>
                    </button>
                </div>
                }

                {this.Model.Options.ShowSubTotal &&
                <div>
                    {this.ShowTotal()}
                </div>
                }
            </div>
        )

    }

    public UpdateContainer(container:HTMLDivElement){
        this.Container=container;
    }

    protected ShowTotal() {
        return(
            <SubTotalContainer FormBuilder={this.Model} Label={this.Model.Options.SubTotalLabel}/>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FBListProps extends FBFieldWithPriceBaseProps{
    Model:FBRepeaterModel;

}

interface FBListState extends FBFieldWithPriceBaseState{

}




EventManager.Subscribe(GetModel,(event)=>{
    if(event.Options.Type==FieldTypeEnum.Repeater)
        return new FBRepeaterModel(event.Options as FBRepeaterOptions,event.parent,event.PreviousData);
});



EventManager.Subscribe(GetFieldOptions,(event)=>{
    if(event.Type==FieldTypeEnum.Repeater)
        return new FBRepeaterOptions();
});

EventManager.Subscribe(GetField,(event)=>{
    if(event.Model.Options.Type==FieldTypeEnum.Repeater)
        return <FBRepeater Model={event.Model as any}/>
});





EventManager.Subscribe(GetModel,(event)=>{
    if(event.Options.Type==FieldTypeEnum.RepeaterItem)
        return new FBRepeaterItemModel(event.Options as FBRepeaterItemOptions,event.parent,event.PreviousData);
});





EventManager.Subscribe(GetFieldOptions,(event)=>{
    if(event.Type==FieldTypeEnum.RepeaterItem)
        return new FBRepeaterItemOptions();
});

EventManager.Subscribe(GetField,(event)=>{
    if(event.Model.Options.Type==FieldTypeEnum.RepeaterItem)
        return <FBRepeaterItem Model={event.Model as any}/>
});

//#endregion "My Region"